<template>
    <section class="gmp-section gmp-mb-l">
        <div class="hero-landing">
            <div class="hero-landing__background hero-landing__overview">
                <div class="gmp-banner gmp-overview-hero">
                    <picture>
                        <img class="gmp-no-grab hero-landing__image" src="@/assets/img/mem_two.png"
                             alt="Meaningful insights.<br>Smarter marketing.<br>Better results.">
                    </picture>
                </div>
            </div>
            <div class="hero-landing__content">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col--12 h-c-grid__col--align-middle">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                提高群组活跃度
                            </h1>
                            <h2 class="h-c-headline h-c-headline--four">
                                多样化活动：下单拼单小程序可以为微信群提供丰富多样的活动选项，如团购、拼单、限时抢购等，吸引群成员积极参与，增加群组的活跃度。
                                实时互动：小程序支持实时更新和互动，群成员可以在小程序内参与各种活动，实时查看拼单进度和优惠信息，提升参与感和互动性。
                            </h2>
<!--                            <a href="/" class="h-c-button h-c-button&#45;&#45;primary">-->
<!--                                <div class="gmp-link__content gmp-link__content&#45;&#45;cta-btn">-->
<!--                                    <span>注册企业采购账号</span>-->
<!--                                </div>-->
<!--                            </a>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "MEM_heroLanding"
    }
</script>

<style lang="less">


</style>